module.exports = __webpack_public_path__ + "img/seo_gchess_item02.31fa36c.webp";